import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import { download } from "util/download";

class FullScreenView extends React.PureComponent {
  static get propTypes() {
    return {
      mediaType: PropTypes.oneOf(["image", "video"]),
      url: PropTypes.string,
      hide: PropTypes.func.isRequired,
      filename: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      url: null,
      filename: "asset",
    };
  }

  constructor() {
    super();

    this.container = null;

    this._downloadContent = this._downloadContent.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
  }

  componentDidMount() {
    this._focusContainer();
  }

  componentDidUpdate() {
    this._focusContainer();
  }

  _focusContainer() {
    const { container } = this;
    if (container) {
      container.focus();
    }
  }

  _handleKeyDown(e) {
    const { hide } = this.props;

    if (e.key === "Escape") {
      hide();
    }
  }

  _downloadContent() {
    const { filename, url } = this.props;

    download(url, filename);
  }

  _renderImage(url) {
    return <img src={url} />;
  }

  _renderVideo(url) {
    return (
      <video preload={false} controls={true}>
        <source src={url} />
      </video>
    );
  }

  _renderContent() {
    const { mediaType, url } = this.props;

    if (mediaType === "image") {
      return this._renderImage(url);
    }

    if (mediaType === "video") {
      return this._renderVideo(url);
    }

    return <div>Invalid type. Cannot display.</div>;
  }

  render() {
    const { hide, url } = this.props;
    if (!url) {
      return null;
    }

    return (
      <div
        className="ui-fullscreen-view"
        onKeyDown={this._handleKeyDown}
        tabIndex="0"
        ref={(e) => {
          this.container = e;
        }}
      >
        <div className="float-control-button-row button-spacing">
          <Button
            className="cp-download clear-button"
            onClick={this._downloadContent.bind(this)}
            title="Download"
          >
            <i className="fa fa-download" aria-hidden="true" />
          </Button>
          <Button
            className="cp-expand clear-button"
            onClick={hide}
            title="Close"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </Button>
        </div>
        {this._renderContent()}
      </div>
    );
  }
}

export { FullScreenView };
